import React, { useEffect, useMemo, useState } from 'react'
import { Typography, Box } from '@material-ui/core'
import getDateLabel from 'utils/getDateLabel'
import { useSelector } from 'react-redux'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import DataLoading from 'components/DataLoading'
import { useParams } from 'react-router-dom'

const EventOrSessionInfo = () => {
  const { eventId, sessionId } = useParams()
  const [event, setEvent] = useState({})
  const [session, setSession] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const { conference } = useSelector((state) => state.conference)

  const timezone = useMemo(() => conference?.timezone, [conference])
  const is24hrFormat = useMemo(() => conference?.is24hrFormat, [conference])
  const eventTitle = useMemo(() => event?.title, [event])
  const eventStartDate = useMemo(
    () => (event?.startDate ? getDateLabel(event?.startDate, timezone, is24hrFormat) : ''),
    [event]
  )
  const eventEndDate = useMemo(
    () => (event?.endDate ? getDateLabel(event?.endDate, timezone, is24hrFormat) : ''),
    [event]
  )

  const sessionTitle = useMemo(() => session?.title, [session])
  const sessionStartDate = useMemo(
    () => (session?.startDate ? getDateLabel(session?.startDate, timezone, is24hrFormat) : ''),
    [session]
  )
  const sessionEndDate = useMemo(
    () => (session?.endDate ? getDateLabel(session?.endDate, timezone, is24hrFormat) : ''),
    [session]
  )

  const fetchEvent = async () => {
    const snapshot = await FirestoreDatabase.collection(Collection.EVENTS).doc(eventId).get()
    const eventInfo = snapshot.exists ? { id: snapshot.id, ...snapshot.data() } : {}
    setEvent(eventInfo)
  }

  const fetchSession = async () => {
    const snapshot = await FirestoreDatabase.collection(Collection.SESSIONS).doc(sessionId).get()
    const sessionInfo = snapshot.exists ? { id: snapshot.id, ...snapshot.data() } : {}
    setSession(sessionInfo)
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        if (eventId) {
          await fetchEvent()
        }
        if (sessionId) {
          await fetchSession()
        }
      } catch (error) {
        console.error('Error fetching event or session:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [eventId, sessionId])

  return (
    <Box p={1} border={1}>
      <Box p={1} style={{ backgroundColor: '#ECECEC' }}>
        {isLoading ? (
          <Box p={1} mt={0.5}>
            <DataLoading progressSize={32} />
          </Box>
        ) : (
          <>
            {eventTitle && (
              <Box display="flex">
                <Typography variant="h6" style={{ fontWeight: '700', width: '150px' }}>
                  Event Title:
                </Typography>
                <Box sx={{ ml: '20px' }}>
                  <Typography variant="h6" color="primary">
                    {eventTitle}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: '13px',
                      fontStyle: 'italic',
                      marginTop: '-2px'
                    }}
                    color="textSecondary">
                    {eventStartDate} - {eventEndDate}
                  </Typography>
                </Box>
              </Box>
            )}
            {sessionTitle && sessionStartDate && sessionEndDate && (
              <Box display="flex">
                <Typography variant="h6" style={{ fontWeight: '700', width: '150px' }}>
                  Sub Event Title:
                </Typography>
                <Box sx={{ ml: '20px' }}>
                  <Typography variant="h6" color="primary">
                    {sessionTitle}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: '13px',
                      fontStyle: 'italic',
                      marginTop: '-6px'
                    }}
                    color="textSecondary">
                    {sessionStartDate} - {sessionEndDate}
                  </Typography>
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

export default EventOrSessionInfo
